module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "eloBatch"
    }
  }, [_c('b', [_vm._v("ELOバッチ実行画面")]), _c('br'), _c('br'), _vm._v(" "), _vm._m(0), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "id": "batchBtns"
    }
  }, [_c('h2', [_vm._v("基本評価：")]), _vm._v(" "), _c('button', {
    staticClass: "btn-mid",
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "id": "gameCreateBtn"
    },
    on: {
      "click": function($event) {
        return _vm.gameCreateClick('normal')
      }
    }
  }, [_vm._v("基本評価バッチ実行(Game Create)")]), _vm._v(" \n    "), _c('button', {
    staticClass: "btn-mid",
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "id": "gameClearBtn"
    },
    on: {
      "click": function($event) {
        return _vm.gameClearClick('normal')
      }
    }
  }, [_vm._v("基本評価バッチ実行(Reset)")]), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn-mid",
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "id": "gameRunBtn"
    },
    on: {
      "click": function($event) {
        return _vm.gamePlayClick('normal')
      }
    }
  }, [_vm._v("基本評価バッチ実行(Game Play)")]), _c('br'), _vm._v(" "), _c('h2', [_vm._v("横断評価：")]), _vm._v(" "), _c('button', {
    staticClass: "btn-mid",
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "id": "directEvalGameCreateBtn"
    },
    on: {
      "click": function($event) {
        return _vm.gameCreateClick('DirectEval')
      }
    }
  }, [_vm._v("横断評価バッチ実行(Game Create)")]), _vm._v(" \n    "), _c('button', {
    staticClass: "btn-mid",
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "id": "directEvalGameClearBtn"
    },
    on: {
      "click": function($event) {
        return _vm.gameClearClick('DirectEval')
      }
    }
  }, [_vm._v("横断評価バッチ実行(Reset )")]), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn-mid",
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "id": "directEvalGameRunBtn"
    },
    on: {
      "click": function($event) {
        return _vm.gamePlayClick('DirectEval')
      }
    }
  }, [_vm._v("横断評価バッチ実行(Game Play)")]), _c('br')]), _vm._v(" "), _c('button', {
    staticClass: "btn-mid",
    staticStyle: {
      "width": "300px"
    },
    on: {
      "click": function($event) {
        return _vm.$router.back(-1);
      }
    }
  }, [_vm._v("キャンセル")]), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('tr', [_c('td', [_vm._v("ELOバッチを実行いただきます。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a2495834!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/eloBatch.vue
// module id = 132
// module chunks = 2